export const EngagementServiceEvents = {
  init: {
    success: 'ENGAGEMENT_SERVICE.INIT.SUCCESS',
    failure: 'ENGAGEMENT_SERVICE.INIT.FAILURE',
  },
  pause: {
    started: 'ENGAGEMENT_SERVICE.PAUSE.STARTED',
    ended: 'ENGAGEMENT_SERVICE.PAUSE.ENDED',
  },
  dispose: {
    called: 'ENGAGEMENT_SERVICE.DISPOSE.CALLED',
  },
  inAppMessage: {
    received: 'ENGAGEMENT_SERVICE.IN_APP_MESSAGE.RECEIVED',
    shownControl: 'ENGAGEMENT_SERVICE.IN_APP_MESSAGE.SHOWN_CONTROL',
    deferred: 'ENGAGEMENT_SERVICE.IN_APP_MESSAGE.DEFERRED',
    shown: 'ENGAGEMENT_SERVICE.IN_APP_MESSAGE.SHOWN',
  },
  pushNotification: {
    permission: {
      requested: 'ENGAGEMENT_SERVICE.PUSH_NOTIFICATION.PERMISSION.REQUESTED',
      granted: 'ENGAGEMENT_SERVICE.PUSH_NOTIFICATION.PERMISSION.GRANTED',
      denied: 'ENGAGEMENT_SERVICE.PUSH_NOTIFICATION.PERMISSION.DENIED',
    },
  },
}

export const errorOptions = {
  scope: 'marketing',
  section: 'engagement',
} as const

export const SERVICE_WORKER_LOCATION = '/js/braze.js'

export const PREFERENCE_DATE_KEY = 'web_push_consent_updated_at'

export const SESSION_BRAZE_KEY = 'braze'
